import { render, staticRenderFns } from "./EWTransactionStatement.vue?vue&type=template&id=2cf0fa34&"
import script from "./EWTransactionStatement.vue?vue&type=script&lang=js&"
export * from "./EWTransactionStatement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports